
import { AnaColumn } from "../forms-template.service";


export const crmTipoProcedureGrid: AnaColumn[] = [

    {
      configuration: 
      {
        service: 'crmTipoProcedureForm',
        api: 'tipoprocedure',
        api_rest:true,
        filterList: '',
        filterEditor: '/$',
        // helpDoc: 'Movimentidicaricoescaricorifiuti.html',
        formType: 'simple',
        queryFilter: [],
        idTabRif: [],
        masterKey: 'Cod',
        widthForm:700,
        nCol: 2,
        //ListaHP=H12&ListaHP=H2&ListaHP=H4&
      },

      itemType: "group", colCount: "1", class: "", caption: "Tipo Procedure", 
      data: [
        
          {
            type: 'campo',
            dataField: 'Cod',
            colVisible: false,
            dataType: 'string',
            caption: 'Cod ID',
            colAlignment: 'left',
            colWidth: 50
          },
          {
            type: 'campo',
            dataField: 'Descrizione',
            colVisible: true,
            dataType: 'string',
            caption: 'Descrizione',
            colAlignment: 'left',
            colWidth: 300
          },
      ]
    },

  ];

  export const crmTipoProcedureForm : AnaColumn [] = [

    {
      itemType: 'group',
      caption: 'Modifica Tipo di Procedure ',
      class: '',
      colCount: 4,
      colSpan: 2,
  
      
      data: [
        {
          type: 'campo',
          dataField: 'Cod',
          visible: false,
          dataType: 'string',
          caption: 'Codice ID',
          class: 'crm_banche_editor',
          nCol: 3,
          validation: [{ type: "required", message: "Campo Obbligatorio" }],
          
        },
    
        {
          type: 'campo',
          dataField: 'Descrizione',
          dataType: 'string',
          caption: 'Descrizione',
          class: 'crm_tipo-procedure_editor',
          nCol: 10,  
        },
        
        { type: 'empty', colSpan: '4', },
        //----------------------------------------------------------------

      ],
    },
  ]